export default "__VITE_ASSET__2PRIFpEZ__"